import { Search as SearchIcon } from '@mui/icons-material';
import { Box, Input, Theme } from '@mui/material';
import { useRef } from 'react';

import { useDebouncedCallback } from '@/hooks';

export type Props = { placeHolder: string; onSearch: (search: string) => void };

export const TableSearchBox = ({ placeHolder, onSearch }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedSearch = useDebouncedCallback(onSearch, 250);

  return (
    <Box sx={styles.searchInputContainer}>
      <Input
        disableUnderline
        sx={styles.searchInput}
        startAdornment={
          <SearchIcon
            onClick={() => {
              setTimeout(() => {
                inputRef.current?.focus();
              }, 0);
            }}
          />
        }
        onChange={evt => debouncedSearch(evt.target.value)}
        inputRef={inputRef}
        placeholder={placeHolder}
        aria-controls="table"
        role="search"
      />
    </Box>
  );
};
const SEARCH_INPUT_WIDTH = 180;

const styles = {
  searchInputContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: SEARCH_INPUT_WIDTH,
  },
  searchInput: (theme: Theme) => ({
    input: { color: 'text.main' },
    transition: '0.5s all ease',
    borderRadius: 12,
    backgroundColor: 'grey50',
    pl: 1,
    pr: 2,
    '&>svg': {
      mr: 1,
    },
    '&.Mui-focused': {
      width: 180,
      '&>svg': {
        color: 'blueBlack',
      },
    },
    [theme.breakpoints.up('sm')]: {
      width: 180,
      '&.Mui-focused': {
        width: 180,
        '&>svg': {
          color: 'blueBlack',
        },
      },
    },
  }),
};
